import React from 'react';
import './app.sass';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Config } from './config/config';
import { LoginContainer } from './features/login/container/login.container';
import { PrivateRoute } from './components/private-route/private-route';
import { DashboardContainer } from './features/dashboard/dashboard.container';
import { useSessionService } from './services/session/use-session.service';
import { LandingPagePreviewContainer } from './features/landing-page/container/preview/landing-page.preview.container';
import { LandingPageVendorContainer } from './features/landing-page/vendor/container/landing-page.vendor.container';
import { ToastContainer } from 'react-toastify';
import { ConfigurationVendorContainer } from './features/configuration/container/configuration.vendor.container';
import { AdminLoginContainer } from './features/admin-login/container/admin-login.container';
import {
  LandingPageBackstreetBoysContainer
} from './features/landing-page/features/backstreetboys/containers/landing-page.backstreetboys.container';
import { VerifyUserContainer } from './features/verify-user/container/verify-user.container';

export const App = () => {
  const paths = Config.routePaths;
  const { init } = useSessionService();

  init();

  return (
    <div className='vv-app'>
      <Router>
        <Route exact path={paths.main.path} component={LandingPagePreviewContainer}/>
        <Route exact path={paths.main.event.path} component={LandingPagePreviewContainer}/>
        <Route exact path={paths.main.backstreetboys.path} component={LandingPageBackstreetBoysContainer}/>
        <Route exact path={paths.main.vendor.path} component={LandingPageVendorContainer}/>
        <Route exact path={paths.main.login.path} component={LoginContainer}/>
        <Route exact path={paths.main.login.admin.path} component={AdminLoginContainer}/>
        <Route exact path={paths.main.verifyUser.path} component={VerifyUserContainer}/>
        <PrivateRoute path={paths.main.vendor.configuration.path} component={ConfigurationVendorContainer}/>
        <PrivateRoute path={paths.main.vendor.dashboard.path} component={DashboardContainer}/>
      </Router>
      <ToastContainer/>
    </div>
  );
};
